import $ from 'jquery';

const SELECTOR = '.homepage-slider';

function onDocumentReady() {
    $(SELECTOR).each(initializeElement);
}

function initializeElement(i, el) {
    const $el = $(el);
    const slides = $el.find('.homepage-slide');

    if (slides.length < 2) {
        return;
    }

    $el.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        dots: true,
        infinite: true,
        arrows: false,
    });
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
